const initialState = {
  /*
  登录：
  page-welcome: 欢迎
  page-error: 控件未安装或ukey未安装
  page-form: 登录表单
  page-set-password: 设置密码（初次登录）
  page-reset-password: 重置密码
  */
  loginState: 'page-welcome',
  /*
  重置密码：
  stepOne
  stepTwo
  stepThree
  */
  resetState: 'stepOne',
  // 用户信息
  userInfo: {
    // 客户号
    customerId: '',
    // 用户号
    userId: ''
  },
  /*
  登录方式：
  密码登录 password
  验证码登录 verify-code
  */
  currentWayOfLogin: 'password',
  // 登录成功后的存储信息
  loginInfo: {
    EMP_SID: '',
    customerId: '',
    userId: '',
    reminderMsg: '',
    reminderMsgFlag: 0,
    // 是否首次登录
    passwordSetFlag: false
  },
  /* 忘记密码-活体验证 */
  faceToken: '',
  faceSession: ''
}

const login = {
  namespaced: true,
  // 这里能用Object.assign的原因是，所有对引用类型属性的处理都是指向新地址，譬如state.userInfo = info
  state: Object.assign({}, initialState),
  mutations: {
    // 重置登录态
    RESET_LOGIN_STATE (state) {
      for (const key of Object.keys(initialState)) {
        state[key] = initialState[key]
      }
    },
    SET_LOGIN_STATE (state, loginState) {
      state.loginState = loginState
    },
    SET_RESET_STATE (state, resetState) {
      state.resetState = resetState
    },
    SET_USER_INFO (state, info) {
      // 利用Object.assign定向覆盖属性 防止SET_USER_INFO调用时属性丢失
      const userInfo = Object.assign({}, state.userInfo, info)
      state.userInfo = userInfo
    },
    SET_WAY_OF_LOGIN (state, way) {
      state.currentWayOfLogin = way
    },
    SET_LOGIN_INFO (state, info) {
      // 利用Object.assign定向覆盖属性 防止SET_USER_INFO调用时属性丢失
      const loginInfo = Object.assign({}, state.loginInfo, info)
      state.loginInfo = loginInfo
    },
    SET_FACE_TOKEN (state, faceToken) {
      state.faceToken = faceToken
    },
    SET_FACE_SESSION (state, session) {
      state.faceSession = session
    }
  },
  actions: {
  }
}

export default login
